"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const useActiveSpectrum_1 = require("./useActiveSpectrum");
function useSpectrum(defaultValue = null) {
    const { data } = (0, ChartContext_1.useChartData)();
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    return (0, react_1.useMemo)(() => {
        if (data && activeSpectrum?.id) {
            const datum = data.find((datum) => datum.id === activeSpectrum.id) || defaultValue;
            return datum;
        }
        return defaultValue;
    }, [activeSpectrum, data, defaultValue]);
}
exports.default = useSpectrum;
